import type { FaireProductEntity } from "../../entity_types/product";

export const p_pfh7gst3kg: FaireProductEntity = {
  token: "p_pfh7gst3kg",
  type: "product",
  name: "Pumpkin Spice Chai - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/2dd059ef84673fead6cabbdf8fefe4b992e03a44bbc4a443eb0899b4ba03c6ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/95ed2d76e03f404a3cd867ab50c8e012cb6bc147f1e2993daa8d97588ba46205.jpeg"
  ],
  priceDollars: 58,
  description: "SUPERFOOD TEA BLEND\n\nSuperfood Pumpkin Spice!\n\nThere’s nothing “basic” about this pumpkin spice latte! Organic black tea, real pumpkin, superfoods, and chai spices like tulsi, ginger, cinnamon and vanilla bean make for a soothing, spicy sip. Slip on your coziest cashmere and steep it into a creamy tea latte for perfect autumn vibes, any time of year! \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Drizzle with honey or maple syrup \n * Top with your favourite milk (we love oat!) \n * Make a Pumpkin Spice Chai Latte: steep tea double strength and top with frothed milk. \nWhen to Steep:\n\n\n * As your morning superfood-packed energy boost \n * As a coffee substitute \n * As an afternoon pick-me-up \n * To show your digestion some love \nModerate caffeine levels\n",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:38.778Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
